import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Pipes
import { OrderByPipe } from './pipes/sort.pipe';

// Components
import { PermissionsDirective } from './directives/permission.directive';
import { GlobalModalComponent } from './components/global-modal/global-modal.component';
import { NexusLoaderComponent } from './components/nexus-loader/nexus-loader.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule
    ],
  declarations: [
    OrderByPipe,
    PermissionsDirective,
    GlobalModalComponent,
    NexusLoaderComponent
  ],
  exports: [
    OrderByPipe,
    PermissionsDirective,
    GlobalModalComponent,
    NexusLoaderComponent
  ]
})
export class SharedModule { }
